import styled from 'styled-components'

export const MapLinkBase = styled.div`
  color: var(--color--neutral--600);
`
